<template>
    <div class="coursepdf">
        <van-nav-bar
            :title="name"
            left-arrow
            :fixed="true"
            @click-left="goback()"
        />
       <div id="Vidpreview" v-show="fileType==3" style="width: 100%;height:100vh"></div>
       <img :src="imageUrl" v-show="fileType == 4" style="width:100%;"/>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'showPdf',
    data() {
        return {
            cleartime:null,
            isPPTLog: true,
            demo: null,
            imageUrl:'',
            docUrl: "",
            pdfPage: '',
            saveLearningParams: {
                recordId: '',
                detailId: '',
                pollingTime: '3',
                curSecond: '',
            },
            fileUrl:'',
            name: '',
            cur: 1,
            fileType:null,
            pdfIntervalName: null,
            courseInfo: {},
            saveLogtime:15,
        };
    },
    async created() {
        // localStorage.removeItem('page')
        // localStorage.removeItem('totalpage')
        const frontendConfigArr = (sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig'))) || this.$store.state.dynamic.frontendConfig || [];
        const saveLogtime = frontendConfigArr.length && frontendConfigArr.filter(item => {
            if(item.key === 'course_saveLog_time'){
                return true
            }
        })[0];
        this.saveLogtime = (saveLogtime && saveLogtime.value) || 15;
        this.duration=this.$route.query.duration;
        sessionStorage.setItem('imgOrPdf', true)
             this.name = this.$route.query.name;
            this.fileType = this.$route.query.type;
            this.cur = this.$route.query.cur;
            // this.pdfPage = this.$route.query.cur ? this.$route.query.cur : 1;
        if(+this.$route.query.type === 4){
            this.getImageOrDocUrl();
            this.pdfTiming();
        }
        // 下边是安全才有的
        // eslint-disable-next-line no-undef
        if(+this.fileType === 3){
            this.getSourseDetail();
            this.getDocumentAccessToken()
        }
        
        
    },
    methods: {
        goback(){
            // if(this.$route.query.backType ==='/learning/task/detail'){
            //     // 临时解决 go-1 不生效
            //     this.$router.push({
            //         path:'/learning/task/detail',
            //         query:{
            //             id:this.$route.query.taskId,
            //             backPath: this.$route.query.backPath,
            //             goodsId:this.$route.query.goodsId,
            //             goodsKind:this.$route.query.goodsKind,
            //             distributionUserId:this.$route.query.distributionUserId
            //         }
            //     })
            // }else{
                // this.$router.go(-1)
            // }
            if(this.$isapp){
                this.$WDJSBridge.useBack()
            }else{
                this.$router.go(-1);
            }
        },
        /**
         * 文档地址
         */
        async getSourseDetail(){
            const params = {
                id:this.$route.query.id
            }
            return this.$api.resource.getSourseDetail({params}).then(res => {
                if(res.data){
                    this.fileUrl = res.data.fileUrl
                }
            })
        },
        /**
         * 图片地址
         */
        async getImageOrDocUrl (){
            const params = {
                id:this.$route.query.id
            }
            return this.$api.resource.getImageOrDocUrl({params}).then(res => {
                if (res.success) {
                    this.imageUrl = res.data;
                }
            })
        },
        /**
         * 获取文档密钥
         */
        async getDocumentAccessToken () {
            const params = this.$route.query.id;

            return this.$api.resource.getDocumentAccessToken(params).then(res => {
                if (res.success) {
                    this.docUrl = res.data.previewURL;
                    // this.accessToken = res.data.accessToken;


                    /* eslint-disable */
                    this.demo = aliyun.config({
                        mount: document.querySelector('#Vidpreview'),
                        url: this.docUrl //设置文档预览URL地址。
                    })
                    // console.log('demo',demo)
                    // //设置AccessToken。
                    this.demo.setToken({token: res.data.accessToken});
                    
                    // await this.demo.ready()
                    // const app = this.demo.Application
                    // const {Enum} = app
                    
                    // if(this.fileUrl.includes('.ppt') || this.fileUrl.includes('.pptx')){
                        
                    //     let totalPagesz = await this.demo.PPTApplication().ActivePresentation.Slides.Count
                    //     localStorage.setItem('page',totalPagesz)
                    //     localStorage.setItem('totalpage',totalPagesz)
                    //     /***
                    //      * 
                    //      * 当前页数必须是切换生效，滚动页面不生效
                    //      */
                    //     // let totalPages = await demo.PPTApplication().ActivePresentation.SlideShowWindow.View.Slide.SlideIndex 
                    //     /*
                    //     * 跳转指定页
                    //     * @param: number
                    //     */
                    //     // await demo.PPTApplication().ActivePresentation.SlideShowWindow.View.GotoSlide(3)
                    // }else if(this.fileUrl.includes('.pdf')){
                    //     let totalPages = await this.demo.PDFApplication().ActivePDF.PagesCount
                    //     localStorage.setItem('page',totalPages)
                    //     localStorage.setItem('totalpage',totalPages)
                    //     /*
                    //     * 获取当前呀
                    //     * @return: number
                    //     */
                    //     // let totalPages = await demo.PDFApplication().ActivePDF.CurrentPage
                    //     /*
                    //     *  跳转到相应页
                    //     * @param : { PageNum: number }
                    //     */
                    //     //  let PageNum = 10
                    //     // await demo.PDFApplication().ActivePDF.JumpToPage({PageNum})
                    // }else if(this.fileUrl.includes('.doc') || this.fileUrl.includes('.docx')){
                    //     console.log('app',app)
                    //     let totalPages = await app.ActiveDocument.Range.Information(Enum.WdInformation.wdNumberOfPagesInDocument)
                    //     if (totalPages.End) {
                    //         console.log("加载完了！一共", totalPages.PagesCount, "页")
                    //         localStorage.setItem('page',totalPages.PagesCount)
                    //         localStorage.setItem('totalpage',totalPages.PagesCount)
                    //     }
                    //     /*
                    //     * 获取当前呀
                    //     * @param: WdInformation: {
                    //     *      wdActiveEndPageNumber: 3
                    //     *  }
                    //     * @return: number
                    //     */
                    //     // let currentPage = await app.ActiveDocument.Selection.Information(Enum.WdInformation.wdActiveEndPageNumber)
                    //     /*
                    //     * 跳转指定
                    //     * @param: { What?: WdGoToItem, Which?: WdGoToDirection.wdGoToAbsolute, Count?: number, Name?: string}
                    //     * WdGoToItem: {
                    //     *      wdGoToPage: 1,
                    //     *  }
                    //     *  WdGoToDirection: {
                    //     *      wdGoToAbsolute: 1
                    //     *  }
                    //     */
                    //     // await app.ActiveDocument.Selection.GoTo(Enum.WdGoToItem.wdGoToPage, Enum.WdGoToDirection.wdGoToAbsolute, 10)
                    //     // //或者使用如下代码。
                    //     // await app.ActiveDocument.Selection.GoTo({
                    //     //     What: Enum.WdGoToItem.wdGoToPage,
                    //     //     Which: Enum.WdGoToDirection.wdGoToAbsolute,
                    //     //     Count: 10
                    //     // })
                    // }else if(this.fileUrl.includes('.xls') || this.fileUrl.includes('.xlsx')){
                    //     const Names = []
                    //     //For(start, end, step, handle)
                    //     await app.For(1, app.Sheets.Count, 1, async (Index) => {
                    //         Names.push(await app.Sheets.Item(Index).Name)
                    //     })
                    //     console.log(Names,'Names---')
                    //     localStorage.setItem('page',Names.length)
                    //     localStorage.setItem('totalpage',Names.length)
                    //     // 获取当前sheet名称
                    //     // await demo.ready()
                    //     // const app = demo.ExcelApplication()
                    //     // const name = await app.ActiveSheet.Name
                    //     // console.log('ActiveSheet:', name)
                    //     // 切换到指定sheet
                    //     // await demo.ready()
                    //     // const app = demo.ExcelApplication()
                    //     // const sheetIndex = 1 //sheets序号，从1开始。
                    //     // app.Sheets.Item(sheetIndex).Activate() //切换sheet。
                    // }




                    /* eslint-disable */
                }
            })
        },
        
        pdfTiming({page, totalpage} = {}) {
            // this.pdfIntervalName = setInterval(() => {
                this.saveLearningLog({page, totalpage});
                this.postUserLearningLog();
            // }, 3000);
        },
        clearTimeing() {
            if (this.pdfIntervalName) {
                clearInterval(this.pdfIntervalName);
                this.pdfIntervalName = null;
            }
        },
        async saveLearningLog({page, totalpage} = {}) {
            const data = {
                courseId: this.$route.query.courseId,
                taskId: this.$route.query.taskId || '',
                courseItemId: this.$route.query.courseItemId,
                cur: this.duration || 1,
                max: this.duration || 1,
                pollingTime: this.saveLogtime || 15 ,
                taskType:this.$route.query.taskType,
            }
            return await this.$api.course.postCourseLearningLogSaveLog({ data }).then(res => {
                console.debug(res)
            })

            // const data = {
            //     courseId: this.$route.query.courseId,
            //     taskId: this.$route.query.trainId || '',
            //     taskType:this.$route.query.taskType,
            //     courseItemId: this.currentlyPlay.id,
            //     cur,
            //     max,
            //     pollingTime: 5
            // }
            // return await this.$api.course.postCourseLearningLogSaveLog({ data }).then(res => {
            //     console.debug(res)
            // })
            //  true;
        },
        async postUserLearningLog () {
            const data = {
                learningLength: this.saveLogtime || 15
            }
            await this.$api.course.postUserLearningLog({ data }).then(() => {})
        },
    },
    beforeDestroy() {
        clearInterval(this.cleartime)
        // this.clearTimeing();
        // 离开当前路由删除 文档元素
        let Vidpreview=document.querySelector('.web-office-default-container')
        if(Vidpreview){
            document.body.removeChild(Vidpreview)
        }
    },
    destroyed() {
        clearInterval(this.cleartime)
        // window.removeEventListener("popstate", this.pdfTiming, false); //false阻止默认事件
    },
    async mounted () {
        
        // await this.demo.ready()
        // if (window.history && window.history.pushState) {
        //     // 往历史记录里面添加一条新的当前页面的url
        //     history.pushState(null, null, document.URL);
        //     // 给 popstate 绑定一个方法 监听页面刷新
        //     window.addEventListener("popstate", this.pdfTiming, false); //false阻止默认事件
        // }
        const saveLogtime = +this.saveLogtime * 1000;
        this.cleartime=setInterval(val=>{
            this.pdfTiming();
        },saveLogtime)
        // this.demo.PDFApplication && await this.demo.PDFApplication().ActivePDF.JumpToPage({PageNum: this.cur || 1})
        // this.demo.PDFApplication && (this.demo.PDFApplication().Sub.CurrentPageChange = async () => {
        //     const totalpage = await this.demo.PDFApplication().ActivePDF.PagesCount
        //     const page = await this.demo.PDFApplication().ActivePDF.CurrentPage
        //     this.pdfTiming({page, totalpage})
        // })
        // this.demo.ExcelApplication && (async () => {
        //     let totalpage = await this.demo.ExcelApplication()
        //     // let page = await await this.demo.ExcelApplication().ActiveSheet.Name
        //     let idx = 1
        //     totalpage.For(1, totalpage.Sheets.Count, 1, async (Index) => {
        //         // totalpage.Sheets.Item(Index).Name
        //         idx++
        //     })
        //     this.pdfTiming({page: idx, totalpage: idx})
        // })
        // this.demo.PPTApplication && (this.demo.PPTApplication().Sub.SlideSelectionChanged = async () => {
        //     if (this.isPPTLog) {
        //         this.isPPTLog = false
        //         const totalpage = await this.demo.PPTApplication().ActivePresentation.Slides.Count
        //         this.pdfTiming({page: totalpage, totalpage})
        //     }
            
        // })
        
    },
    
};
</script>

<style scoped lang="less">
.coursepdf {
    width: 100%;
    height: 100%;
}
</style>
